<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight - 6"
      size="small"
      resizable
      border
      show-footer
      :footer-method="() => footerData"
      ref="table"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:expandContent="{ row }">
        <BoxTable
          :disabled="disabled"
          :isExpand="true"
          :shipmentCode="row.shipmentCode"
          :shipmentContainerCode="row.shipmentContainerCode"
          :expand="true"
          @reload="$emit('reload')"
          class="m-2"
        />
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_view') || '查看'"
            placement="top"
          >
            <i
              class="el-icon-view tool-btn"
              @click="
                $emit('openEditFormDialog', {
                  type: 'detail',
                  code: row.shipmentContainerCode,
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_edit') || '编辑'"
            placement="top"
            v-if="!disabled"
          >
            <i
              class="el-icon-edit tool-btn"
              @click="
                $emit('openEditFormDialog', {
                  type: 'edit',
                  code: row.shipmentContainerCode,
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
            v-if="!disabled"
          >
            <i class="el-icon-delete tool-btn" @click="del(row)"></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:containerAmount="{ row }">
        <span>{{ row.containerPriceAmount }}{{ row.v_currencyUnit }}</span>
      </template>
      <template v-slot:containerSalePrice="{ row }">
        <span
          >{{ row.containerSalePriceAmout }}{{ row.v_salesCurrencyUnit }}</span
        >
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import BoxTable from '../box-table'
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
export default {
  components: { BoxTable },
  mixins: [TableAutoHeight],
  props: {
    tableData: { type: Array, default: () => [] },
    tableTotal: { type: Object, default: () => {} },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
        zoom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
  computed: {
    footerData() {
      if (!this.tableTotal) return [[]]
      const {
        containerBoxVolume,
        containerBookingVolume,
        containerBoxQty,
        containerNetWeight,
        containerGrossWeight,
        containerGoodsQty,
        containerPriceAmount,
        containerSalePriceAmout,
      } = this.tableTotal

      return [
        [
          this.$l('INDEX.total') || '合计',
          '',
          '',
          '',
          '',
          '',
          '',
          containerBoxVolume,
          '',
          '',
          '',
          containerBookingVolume,
          containerBoxQty,
          containerNetWeight,
          containerGrossWeight,
          containerGoodsQty,
          containerPriceAmount,
          containerSalePriceAmout,
        ],
      ]
    },
  },
  watch: {
    footerData: {
      handler() {
        if (this.$refs.table) this.$refs.table.updateFooter()
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    del({ shipmentCode, shipmentContainerCode }) {
      this.$confirm(
        this.$l('INDEX.tips_delete_shipmentContainer') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.$api
          .shipmentContainerDelApi({
            shipmentCode,
            shipmentContainerCodeList: [shipmentContainerCode],
          })
          .then(() => {
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
              type: 'success',
            })
            this.$emit('reload')
          })
      })
    },
  },
}
</script>
